import React from 'react'
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaTiktok} from 'react-icons/fa'
import './Footer.css'
import { FaF } from 'react-icons/fa6'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>ABOUT ME</h3>
          <p>A community for developers to learn, share knowledge, and build their careers.</p>
        </div>

        <div className="footer-section">
          <h3>CONTACT</h3>
          <p>Email: taovietduc.work@gmail.com</p>
          <div className="social-links-footer">
            <a href="https://www.facebook.com/TAOVIETDUCOFFICIAL" target="_blank" rel="noopener noreferrer"> 
              <FaFacebook size={20} />
            </a>
            <a href="https://www.instagram.com/taovietduc_" target="_blank" rel="noopener noreferrer">
              <FaInstagram size={20} />
            </a>
            <a href="https://www.tiktok.com/@taovietduc_" target="_blank" rel="noopener noreferrer">
              <FaTiktok size={20} />
            </a>
            <a href="https://github.com/taovietducofficial" target="_blank" rel="noopener noreferrer">
              <FaGithub size={20} />
            </a>
            <a href="https://www.linkedin.com/in/taovietduc19/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={20} />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>NEWSLETTER</h3>
          <p>Subscribe to our newsletter for updates</p>
          <div className="newsletter-form">
            <input type="email" placeholder="Enter your email" />
            <button>Subscribe</button>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2024 TÀO VIỆT ĐỨC. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
